import { ListAlt } from '@mui/icons-material'
import RentSectionCreate from './RentSectionCreate'
import RentSectionEdit from './RentSectionEdit'
import RentSectionList from './RentSectionList'

const musicSectionIndex = {
  icon: ListAlt,
  list: RentSectionList,
  edit: RentSectionEdit,
  create: RentSectionCreate,
}

export default musicSectionIndex
